export default __webpack_public_path__ + "static/media/discover.d2238abf.jpg";